import { Component } from '@angular/core';
import {  NavController, NavParams, ToastController, AlertController, LoadingController  } from 'ionic-angular';
import { Globals } from '../../providers/globals';

import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';
import { BusinessProductExpeditorHandlerProvider } from '../../providers/business-product-expeditor-handler';

@Component({
  selector: 'page-business-product-expediter-invoice-detail',
  templateUrl: 'business-product-expediter-invoice-detail.html',
})
export class BusinessProductExpediterInvoiceDetailPage {
	isLoading: boolean = false;
	isRedeeming: boolean = false;
	isRedeemed: boolean = false;
	invoice: any;
	invoiceDetail: any;
	og: any;
	filePath: any;

	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler, 
		public mainService: BusinessProductExpeditorHandlerProvider,
		public alertCtrl: AlertController,
		public toastCtrl: ToastController,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public globals: Globals, 
		public navParams: NavParams) {

		this.invoice = navParams.data["invoice"];
		this.filePath = this.globals.fileUrl;

		if(this.invoice.GroupJSON){
			this.og = JSON.parse(this.invoice.GroupJSON)[0].products;	
		}	
	}

	confirmRedeem(){
	    let alert = this.alertCtrl.create({
	      title: 'Close Ticket?',
	      message: 'Are you sure you want to close this ticket?',
	      buttons: [
	        {
	          text: 'Cancel',
	          role: 'cancel',
	          handler: () => {
	            
	          }
	        },
	        {
	          text: 'Confirm',
	          handler: () => {  
	            this.redeem();
	          }
	        }
	      ]
	    });

	    alert.present();
  	}	    

  	loadDetail(){
		return new Promise( (resolve, reject) => {

	  		this.mainService.getInvoice(this.invoice.Id).then((data: any)=>{
	  			this.invoice = data.Data;

	  			this.mainService.refreshOrders();

	  			resolve();
	  		});

		});    	
  	}

	redeem(){
	    if(this.isRedeeming) return;

	    this.isRedeeming = true;

		var loader = this.loadingCtrl.create({
			content: "Closing ticket...",
			showBackdrop: true
		});

		loader.present(); 

	    this.mainService.redeem({
	      invoiceId: this.invoice.Id,
	      cb:(result)=>{	      	
	        if(result.Success){
	          let alert = this.alertCtrl.create({
	            title: 'Success',
	            subTitle: 'Ticket has been closed!',
	            buttons: ['Ok']
	          });

	          alert.present();	          

	          this.isRedeemed = true

	          this.isRedeeming = false;

	          this.loadDetail().then(()=>{
	          	loader.dismiss(); 
	          });
	        } else { 
          		loader.dismiss(); 

	          	let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });
	            
	            alert.present();

	            this.isRedeeming = false; 
	        }
	      }
	    });
  	}
}



// WEBPACK FOOTER //
// ./src/pages/business-product-expediter-invoice-detail/business-product-expediter-invoice-detail.ts